"use client"

import { useState } from "react"
import UploadPhotoModal from "../components/modals/uploadPhotoModal"
import Modal from "../components/modals/modal"
import ConfirmationModal from "../components/modals/confirmationModal"
import profileUpdatedModalIcon from "../assets/icons/profile-updated-modal-icon.svg"
import logoutModalIcon from "../assets/icons/logout-modal-icon.svg"
import ChangePasswordModal from "../components/modals/changePasswordModal" 
import EditProfileModal from "../components/modals/editProfileModal"
import AddCitationModal from "../components/modals/add-citation/addCitationModal"
import avatarIcon from "../assets/icons/avatar.svg"
import Step1ImportDocModal from "../components/modals/import-document/step1-import-doc-modal"
import Tooltip from "../components/shared/Tooltip"


export default function TestPage() {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false)
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false)
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false) // <-- state for new modal
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false) // State for edit profile modal
  const [isImportDocModalOpen, setIsImportDocModalOpen] = useState(false)
  const [isCitationModalOpen, setIsCitationModalOpen] = useState(false)
 // Dummy user data
  const [userProfile, setUserProfile] = useState({
    firstName: "Dr. Bridgette",
    lastName: "Hill",
    email: "info@writform.com",
    photo: avatarIcon,
  })


  const handleUploadDrive = () => {
    setIsUploadModalOpen(false)
  }

  const handleUploadDevice = () => {
    setIsUploadModalOpen(false)
  }

  const handleLogout = () => {
    setIsLogoutModalOpen(false)
  }

  const handleChangePassword = (oldPassword, newPassword) => {
    setIsChangePasswordOpen(false)
  }

    const handleSaveProfile = (updatedProfile) => {
    setUserProfile(updatedProfile) // Update the user profile state
    setIsEditProfileModalOpen(false)
  }

  const handleFileSelect = (file) => {
    console.log("File selected:", file.name)
  }

  const handleNextStep = (file) => {
    console.log("Proceeding to next step with file:", file.name)
    setIsImportDocModalOpen(false)
  }

  const handleAddCitation = (citationData) => {
    console.log("Citation added:", citationData)
    setIsCitationModalOpen(false)
  }

  return (
    <div className="min-h-screen bg-bgColor w-full px-4 sm:px-6 lg:px-8 py-6 lg:py-10 max-w-[1200px] mx-auto">
      <h1 className="text-2xl sm:text-3xl font-bold text-dark-blue mb-4">
        Test Page
      </h1>
      <p className="text-gray mb-6">
        This is just a test page so we can verify the layout with the Navbar and Sidebar.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        <div className="bg-white p-4 sm:p-6 shadow rounded-xl border border-gray-100 h-full">
          <h2 className="text-lg font-semibold text-dark-blue mb-2">Card One</h2>
          <p className="text-sm text-gray">
            Sample content for the first card. Resize the window to check responsiveness.
          </p>
        </div>

        <div className="bg-white p-4 sm:p-6 shadow rounded-xl border border-gray-100 h-full">
          <h2 className="text-lg font-semibold text-dark-blue mb-2">Card Two</h2>
          <p className="text-sm text-gray">
            Another placeholder card with some text.
          </p>
        </div>

        <div className="bg-white p-4 sm:p-6 shadow rounded-xl border border-gray-100 h-full">
          <h2 className="text-lg font-semibold text-dark-blue mb-2">Card Three</h2>
          <p className="text-sm text-gray">
            Last test card for layout validation.
          </p>
        </div>
      </div>

      {/* Buttons to open modals */}
      <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-4">
        <button
          onClick={() => setIsUploadModalOpen(true)}
          className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-[#F36E49] to-[#B67FE2] text-white rounded-xl font-medium hover:opacity-90 transition"
        >
          Open Upload Photo Modal
        </button>

        <button
          onClick={() => setIsProfileModalOpen(true)}
          className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-[#F36E49] to-[#B67FE2] text-white rounded-xl font-medium hover:opacity-90 transition"
        >
          Open Profile Update Modal
        </button>

        <button
          onClick={() => setIsLogoutModalOpen(true)}
          className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-[#F36E49] to-[#B67FE2] text-white rounded-xl font-medium hover:opacity-90 transition"
        >
          Open Logout Confirmation
        </button>

        <button
          onClick={() => setIsChangePasswordOpen(true)} // <-- open password modal
          className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-[#F36E49] to-[#B67FE2] text-white rounded-xl font-medium hover:opacity-90 transition"
        >
          Open Change Password Modal
        </button>
                <button
          onClick={() => setIsEditProfileModalOpen(true)}
          className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-[#F36E49] to-[#B67FE2] text-white rounded-xl font-medium hover:opacity-90 transition"
        >
          Open Edit Profile Modal
        </button>
        <button
          onClick={() => setIsImportDocModalOpen(true)}
          className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-[#F36E49] to-[#B67FE2] text-white rounded-xl font-medium hover:opacity-90 transition"
        >
          Open Import Document Modal
        </button>
        <button
          onClick={() => setIsCitationModalOpen(true)}
          className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-[#F36E49] to-[#B67FE2] text-white rounded-xl font-medium hover:opacity-90 transition"
        >
          Open Add Citation Modal
        </button>
      </div>
      <Tooltip content="This is a hover tooltip">
  Hover me
</Tooltip>

<div className="relative inline-block group">
  <button
    className="bg-primary inline-flex rounded text-base font-semibold text-black whitespace-nowrap"
  >
    Light Tooltip
  </button>
  <div
    className="absolute bottom-full left-1/2 z-20 mb-3 -translate-x-1/2 whitespace-nowrap rounded-md bg-white py-2 px-4 text-xs text-gray-800 font-medium transition-opacity duration-300 border border-gray-300 shadow-[0px_12px_30px_-4px_rgba(16,24,40,0.08);]
               opacity-0 invisible group-hover:opacity-100 group-hover:visible"
    role="tooltip"
  >
    <span
      className="absolute -bottom-1.5 left-1/2 -z-10 h-3 w-3 border-b border-r border-gray-300 -translate-x-1/2 rotate-45 bg-white"
    ></span>
    This is a tooltip
  </div>
</div>

<div className="relative inline-block group">
  <button
    className="bg-primary inline-flex rounded text-base font-semibold text-black whitespace-nowrap"
  >
    Dark Tooltip
  </button>
  <div
    className="absolute bottom-full left-1/2 z-20 mb-3 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-900 py-2 px-4 text-xs text-gray-50 font-medium transition-opacity duration-300 shadow-[0px_12px_30px_-4px_rgba(16,24,40,0.08);]
               opacity-0 invisible group-hover:opacity-100 group-hover:visible"
    role="tooltip"
  >
    <span
      className="absolute -bottom-1.5 left-1/2 -z-10 h-3 w-3 -translate-x-1/2 rotate-45 bg-gray-900"
    ></span>
    This is a tooltip
  </div>
</div>

                    

      {/* Upload Photo Modal */}
      <UploadPhotoModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        onUploadDrive={handleUploadDrive}
        onUploadDevice={handleUploadDevice}
      />

      {/* Profile Update Modal */}
      <Modal
        isOpen={isProfileModalOpen}
        onClose={() => setIsProfileModalOpen(false)}
        icon={<img src={profileUpdatedModalIcon} alt="Profile Updated" className=" mx-auto" />}
        heading="Profile photo updated"
        description="Your WriteForm account profile photo updated successfully"
        buttonText="View profile"
        onButtonClick={() => {
          setIsProfileModalOpen(false)
        }}
      />

      {/* Logout Confirmation Modal */}
      <ConfirmationModal
        isOpen={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
        icon={<img src={logoutModalIcon} alt="Logout" className="mx-auto" />}
        heading="Are you logging out?"
        description="You can always log back in at any time and create or edit your documents."
        primaryButtonText="Cancel"
        secondaryButtonText="Logout"
        onPrimaryClick={() => setIsLogoutModalOpen(false)}
        onSecondaryClick={handleLogout}
      />

      {/* Change Password Modal */}
      <ChangePasswordModal
        isOpen={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
        onChangePassword={handleChangePassword}
      />
        <EditProfileModal
        isOpen={isEditProfileModalOpen}
        onClose={() => setIsEditProfileModalOpen(false)}
        userProfile={userProfile}
        onSaveProfile={handleSaveProfile}
      />
      <Step1ImportDocModal
        isOpen={isImportDocModalOpen}
        onClose={() => setIsImportDocModalOpen(false)}
        onFileSelect={handleFileSelect}
        onNextStep={handleNextStep}
      />
      
      {/* Add Citation Modal */}
      <AddCitationModal
        isOpen={isCitationModalOpen}
        onClose={() => setIsCitationModalOpen(false)}
        onAddCitation={handleAddCitation}
      />
    </div>
  )
}
